import { useState, useEffect, useCallback } from 'react';
import type { ChangeEvent, ComponentProps } from 'react';
import { Box, Input, Label } from './Checkbox.styles';

type CheckboxProps = ComponentProps<'input'> & {
  label?: string;
  checked?: boolean;
};

const Checkbox = ({
  id,
  label,
  checked = false,
  className,
  onChange,
  ...props
}: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setIsChecked(event.target.checked);
      onChange?.(event);
    },
    [onChange],
  );

  return (
    <Label htmlFor={id} className={className}>
      <Input
        {...props}
        id={id}
        type="checkbox"
        defaultChecked={checked}
        onChange={handleChange}
      />
      <Box aria-hidden="true" $isChecked={isChecked}>
        {isChecked && (
          <svg viewBox="0 0 24 24" role="img">
            <path d="M8.6 16.6 20.34 5.28a1 1 0 0 1 1.39 1.44l-12.44 12a1 1 0 0 1-1.48-.1l-5.62-5.43a1 1 0 0 1 1.39-1.44l5.03 4.86Z" />
          </svg>
        )}
      </Box>
      {label}
    </Label>
  );
};

export { Checkbox };
